import { graphql } from "../generated";

export const ProjectVariantsDocument = graphql(`
  query ProjectVariants($key: ID!) {
    project(key: $key) {
      key
      # Whether the viewer can read a delivered head at all: each slot's
      # current version for this viewer, elected on the server, with a
      # delivered verdict — an in-progress upload never counts, and a
      # replaced version is not a head whatever its verdict reads
      # (docs/deliverable-status-seam/SCOPE.md, Train B-0 step 1). One exact,
      # plan-filtered number (rows the viewer may not read are uncounted),
      # answered without walking the concept tree below.
      deliverables(
        params: {
          filter: { latestOnly: true, verdicts: [IN_REVIEW, CHANGES_REQUESTED, APPROVED] }
          pagination: { pageIndex: 0, pageSize: 1 }
        }
      ) {
        meta {
          recordCount
        }
      }
      concepts(params: { sort: [{ field: "serialNumber", order: ASC }] }) {
        nodes {
          key
          variants {
            nodes {
              key
              sequence
              type
              specifications {
                nodes {
                  key
                  progressStatus
                  # The variant's delivery fact: the lineage's latch — any
                  # version this specification HOLDS reached the client — never
                  # the head's, which flips back on an internal re-upload
                  # (D-TA-3 (b)).
                  hasReachedReviewStage
                  deliverable {
                    key
                    verdict
                    # The election's own answer on the row it elected: the
                    # sort rank reads the head relation, never a verdict value.
                    isHead
                    hero
                  }
                  sourceDeliverable {
                    key
                  }
                  format {
                    key
                    length
                    dimension {
                      width
                      height
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
